/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

document.addEventListener("algolia.hooks.initialize", () => {
  const handleItemClick = (e, lineItem) => {
    const afterClick = new Event("algoliaShopify.autocomplete.hitClickAction");
    document.dispatchEvent(afterClick);

    if (algoliaShopify.config.analytics_enabled) {
      const clickData = {
        index: lineItem.__autocomplete_indexName,
        eventName: "Added to cart",
        queryID: lineItem.__autocomplete_queryID,
        objectIDs: [lineItem.objectID],
      };
      algoliaShopify.saveForConversionTracking(clickData);
    }

    const customerCustomAction = algoliaShopify.hooks.triggerHooks(
      "afterAutocompleteProductClickAction",
      undefined,
      lineItem
    );

    if (typeof customerCustomAction === "function") {
      customerCustomAction();
    }
  };

  /* Autocomplete product tile template */
  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate", (_defaultTemplate, templateOptions, distinct, itemLink) => {
    const { html, item, components } = templateOptions;
    return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${event => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent">
        <div class="d-flex gap-1 align-items-center justify-content-between gy-3 w-100">
          <div class="px-2 py-1" style="height: 40px;max-width:100px;">
            <img src="${window.theme.cdnURL}brand-${item.vendor.toLowerCase().replace("& ","").replace(/ /g,"-")}_x30.png" onerror="this.nextElementSibling.style.display = 'block';this.remove();" alt="${item.vendor}" loading="lazy" />
            <div class="label-small product-vendor" style="display:none">${item.vendor}</div>
          </div>
          <div data-bv-show="inline_rating" data-bv-product-id="${item.id}" data-bv-seo="false" class="px-2 py-1"></div>
        </div>

        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img src="${algoliaShopify.helpers.compactImage(item)}" alt="${item.title}" loading="lazy" />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle h5">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition (item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentSKUWrapper">
            <div class="aa-ItemContentSKU text-border body-3 fw-bold">
              ${components.Highlight({ hit: item, attribute: "sku" })}
            </div>
          </div>
          <div class="aa-ItemContentPrice d-flex align-items-center ${item.compare_at_price > 0 && html`sale`}">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
            <div class="aa-ItemContentPriceSave">
              ${item.compare_at_price > 0 && html`<span class="product-tile-compare-price body-3 fw-bold d-flex flex-column flex-md-row">SAVE $${(item.compare_at_price - item.price)}</span>`}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
  });

  /* Search main template */
  algoliaShopify.hooks.registerHook("beforeInstantSearchMainTemplate", (_defaultTemplate, data, html) => html`
      <div class="ais-page container">
        <div class="ais-input hide">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>

        <div class="ais-facets-button button button-primary button-icon">
          <i><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon"><path d="M4.64 5.281c-.622.075-1.08.311-1.581.816-.567.57-.788 1.104-.788 1.903 0 .494.071.81.28 1.24.206.425.784 1.003 1.209 1.209.43.209.746.28 1.24.28s.81-.071 1.24-.28c.425-.206 1.003-.784 1.209-1.209.209-.43.28-.746.28-1.24s-.071-.81-.28-1.24c-.206-.425-.784-1.003-1.209-1.209a2.868 2.868 0 00-1.6-.27m.912 1.594c.217.112.458.352.576.573.077.145.092.233.092.552 0 .435-.066.606-.34.88s-.445.34-.88.34c-.319 0-.407-.015-.552-.092a1.516 1.516 0 01-.573-.576c-.105-.206-.145-.655-.079-.899.094-.348.477-.746.818-.852.219-.067.744-.026.938.074m5.235.403c-.342.067-.519.314-.519.722 0 .462.207.693.663.739.137.014 2.517.02 5.289.013 4.957-.012 5.042-.013 5.176-.092a.646.646 0 00.327-.475c.069-.367-.054-.684-.327-.845-.134-.079-.213-.08-5.296-.086-2.838-.003-5.229.008-5.313.024m7.853 6.003c-.622.075-1.08.311-1.581.816-.567.57-.788 1.104-.788 1.903 0 .494.071.81.28 1.24.206.425.784 1.003 1.209 1.209.43.209.746.28 1.24.28s.81-.071 1.24-.28c.425-.206 1.003-.784 1.209-1.209.209-.43.28-.746.28-1.24s-.071-.81-.28-1.24c-.206-.425-.784-1.003-1.209-1.209a2.868 2.868 0 00-1.6-.27m.912 1.594c.217.112.458.352.576.573.077.145.092.233.092.552 0 .435-.066.606-.34.88s-.445.34-.88.34c-.319 0-.407-.015-.552-.092a1.516 1.516 0 01-.573-.576c-.105-.206-.145-.655-.079-.899.094-.348.477-.746.818-.852.219-.067.744-.026.938.074m-16.765.403c-.342.067-.519.314-.519.722 0 .462.207.693.663.739.137.014 2.517.02 5.289.013 4.957-.012 5.042-.013 5.176-.092a.646.646 0 00.327-.475c.069-.367-.054-.684-.327-.845-.134-.079-.213-.08-5.296-.086-2.838-.003-5.229.008-5.313.024" fill-rule="evenodd"></path></svg></i>
          <span>Filter Results</span>
        </div>

        <div class="ais-search-header">
          <div class="ais-stats-container"></div>
          <div class="ais-change-display">
            <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
            <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
          </div>
          <div class="ais-sort">
            ${data.multipleSortOrders ? html`<span class="ais-sort-orders-label">${algoliaShopify.translations.sortBy}</span> <span class="ais-sort-orders-container"></span>` : html`${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance}`}
          </div>
        </div>

        <div class="ais-facets prevent-animation">
          <div class="ais-facets-header text-white bg-primary p-3 fw-bold">
            Filter
            <div class="ais-facets-close">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="icon" viewBox="0 0 20 20"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg>
            </div>
          </div>
          <div class="ais-facets-inner">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map( facet => html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
                <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                <div class="ais-facet-dropdown-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2045 7.8295C11.6438 7.39017 12.3562 7.39017 12.7955 7.8295L19.5455 14.5795C19.9848 15.0188 19.9848 15.7312 19.5455 16.1705C19.1062 16.6098 18.3938 16.6098 17.9545 16.1705L12 10.216L6.0455 16.1705C5.60616 16.6098 4.89384 16.6098 4.4545 16.1705C4.01517 15.7312 4.01517 15.0188 4.4545 14.5795L11.2045 7.8295Z" fill="#1F1F1F"/>
                  </svg>
                </div>
                <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
              </div>`)}
            </div>
            <div class="ais-facets-button-container">
              <div class="ais-facets-close button button-primary">
                Show Results
              </div>
            </div>
        </div>

        <div class="ais-block">
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>

        <div class="ais-pagination-container"></div>
      </div>
    `);

  /* Search stat template */
  algoliaShopify.hooks.registerHook("beforeInstantSearchStatsTemplate", (_defaultTemplate, data, html) => html`
    ${data.hasOneResult &&
      html`
        <span class="ais-stats--nb-results">
          1 result found
        </span>
      `}
    ${data.hasManyResults &&
      html`
        <span class="ais-stats--nb-results">
          ${algoliaShopify.helpers.formatNumber(data.nbHits)} results found
        </span>
      `}
    `);

  /* Search product tile template */
  algoliaShopify.hooks.registerHook("beforeInstantSearchProductTemplate", (_defaultTemplate, hit, html, components) => {
    const priceArr = algoliaShopify.helpers.displayPrice(hit, hit._distinct).split(".");
    return html`
    <div
      class="ais-hit ais-product"
      data-algolia-index="${hit.index}"
      data-algolia-position="${hit.productPosition}"
      data-algolia-queryid="${hit.queryID}"
      data-algolia-objectid="${hit.objectID}"
      data-handle="${hit.handle}"
      data-variant-id="${hit.objectID}"
      data-distinct="${hit._distinct}"
      data-product-id="${hit.id}"
    >
      <a
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        href="${algoliaShopify.helpers.instantsearchLink(hit)}"
        onclick="void(0)"
        title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
      >

        <div class="d-flex gap-1 align-items-center justify-content-between gy-3">
          <div class="px-2 py-1" style="height: 40px;max-width:100px;">
            <img src="${window.theme.cdnURL}brand-${hit.vendor.toLowerCase().replace("& ","").replace(/ /g,"-")}_x30.png" onerror="this.nextElementSibling.style.display = 'block';this.remove();" alt="${hit.vendor}" loading="lazy"/>
            <div class="label-small product-vendor" style="display:none">${hit.vendor}</div>
          </div>
          <div data-bv-show="inline_rating" data-bv-product-id="${hit.id}" data-bv-seo="false" class="px-2 py-1"></div>
        </div>

        <div class="ais-hit--picture" style="background-image: url('${algoliaShopify.helpers.largeImage(hit)}')">
          <div data-autoload-snippet="product-stickers" class="product-stickers position-absolute mb-3 d-flex flex-wrap gap-2 p-2">
            ${hit.compare_at_price > hit.price && html`<div class="product-sticker product-sticker-sale">Sale</div>`}
          </div>
        </div>

        <div class="ais-hit--details">
          <p class="ais-hit--title h5">${components.Highlight({ attribute: "title", hit })}${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}</p>
          <p class="ais-hit--sku">
            ${hit.sku && html`<span class="algolia-sku">${components.Highlight({ attribute: "sku", hit })}</span>`}
          </p>
          ${!hit._distinct && html`
            <form id="algolia-add-to-cart-${hit.objectID}" style="display: none;" action="/cart/add" method="post" enctype="multipart/form-data">
                <input type="hidden" name="id" value="${hit.objectID}" />
            </form>
            <p class="ais-hit--cart">
              ${hit.can_order ? html`
                <button class="ais-hit--cart-button" data-form-id="algolia-add-to-cart-${hit.objectID}">
                  ${ algolia.translations.addToCart }
                </button>` : html`
                <button class="ais-hit--cart-button ais-hit--cart-button__disabled">
                    ${ algolia.translations.outOfStock }
                </button>`}
            </p>`}
        </div>
        <div class="d-flex flex-row flex-sm-column">
          <div class="flex-grow-1 p-2 d-flex justify-content-between align-items-center fw-bold gap-2 product-tile__price ${hit.compare_at_price > hit.price ? "sale" : ""}">
            <span class="product-tile-final-price">${+priceArr[1] > 0 ? algoliaShopify.helpers.displayPrice(hit, hit._distinct) : priceArr[0]}</span>
            ${hit.compare_at_price > hit.price && html`<span class="product-tile-compare-price body-3 fw-bold d-flex flex-column flex-md-row">SAVE $${(hit.compare_at_price - hit.price).toFixed(2)}</span>`}
          </div>
          <div class="flex-grow-1 p-2 d-flex justify-content-end align-items-center fw-bold gap-2 product-tile__view-product">
            View Product <span class="fs-5"><svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 10a.625.625 0 01.625-.625h14.741l-3.934-3.933a.626.626 0 11.886-.885l5 5a.625.625 0 010 .885l-5 5a.626.626 0 11-.886-.885l3.934-3.932H1.875A.625.625 0 011.25 10z"></path></svg></span>
          </div>
        </div>
      </a>
    </div>
  `
  });

  console.log({ algoliaShopify });
});

document.addEventListener("algolia.instantSearch.afterInit", async () => {
  const $button = document.querySelector(".ais-facets-button");
  const $body = document.querySelector("body");
  const $facets = document.querySelector(".ais-facets");
  const $closeButtons = document.querySelectorAll(".ais-facets-close");

  if ($facets) {
    await delay(300);
    $facets.classList.remove("prevent-animation");
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < $closeButtons.length; ++i) {
    const $closeButton = $closeButtons[i];
    $closeButton.addEventListener("click", () => {
      if ($facets.classList.contains("ais-facets__shown")) {
        $facets.classList.remove("ais-facets__shown");
        $body.classList.remove("fixed-scroll");
      } else {
        $facets.classList.add("ais-facets__shown");
        $body.classList.add("fixed-scroll")
      }
      $button.textContent = "Show filters"
    });
  }
})